import request from '@/utils/request'

// 获取用户列表
export function getuserlist(data) {
  return request({
    url: 'get/users',
    method: 'post',
    params: data
  })
}

// 修改用户登录密码
export function setloginpassword(data) {
  return request({
    url: 'change/user/loginpass',
    method: 'post',
    params: data
  })
}

// 获取子用户列表
export function getsubuserlist(data) {
  return request({
    url: 'get/merch/subusers',
    method: 'post',
    params: data
  })
}

// 修改子用户登录密码
export function setsubuserpassword(data) {
  return request({
    url: 'change/merch/subuser/password',
    method: 'post',
    params: data
  })
}

export function getuserinfobydeliverid(data) {
  return request({
    url: 'get/ownerinfo/bydeliverid',
    method: 'post',
    params: data
  })
}